/**
 * Sentinel a faceted multi-select filter carries when the user picks
 * "Select All". A facet with N options would otherwise enumerate every
 * value into the URL (`col_tagIds=…`), the GET query string, and the 8 KB
 * Redis view-preferences row — past a few hundred values that silently
 * breaks (HTTP 414 / 413). Collapsing the whole set into this one token
 * keeps all three within their limits.
 *
 * Semantics: "every value selected" === "no filter on this facet". The
 * backend treats a facet carrying this token as unconstrained — see the
 * matching `VIEW_FILTER_ALL` constant in the backend's
 * `src/common/constants/view-filter.ts`. The two MUST stay byte-identical.
 */
export const VIEW_FILTER_ALL = "__ALL__"

/** True when a facet's selection is the "Select All" sentinel. */
export function isAllSelected(values: readonly string[]): boolean {
  return values.includes(VIEW_FILTER_ALL)
}
